export default defineNuxtRouteMiddleware((to, from) => {
   const { logInfo } = useDebugger();
   const { getAuthed } = useAuthStore();
   const needAuth =
      to.meta.layout !== "logged-out" || to.name === "school-homepage";
   // Skip redirect if already on login page
   if (to.name === "login-modal" || to.path === "/login") {
      return;
   }

   // if (process.client) return;
   // logInfo("---USER NEEDS AUTH---", !getAuthed, needAuth);

   if (!getAuthed && needAuth) {
      if (process.client) {
         const { addToast } = useToast();
         addToast({
            message: "You need to be logged in to access this page. ",
            isToastButton: true,
            toastButtonText: `Login`,
            status: "error",
         });
      }

      return navigateTo({ path: "/login", query: { redirect: to.fullPath } });
   } else {
      return;
   }
});
